/* Calculate the percentage using the current value and previous value. */
export const convertCurrentPreviousValuePercentage = (
  currentValue: any,
  previousValue: any,
) => {
  return ((currentValue - previousValue) / previousValue) * 100;
};
